import { FC, Fragment, useState } from 'react';
import { hardnessResultColumns } from './createCustomHardness';

import AutTable from '../../blocks/aut-grid-table';
import HardnessResultSummaryForm, { HardnessItem } from '../../forms/custom-hardness/hardnessResultSummaryForm';

interface Props {
	data: HardnessItem[];
	onDataChange: (items: HardnessItem[]) => void;
}

const HardnessResultPreview: FC<Props> = (props) => {
	const [itemToEdit, setItemToEdit] = useState<HardnessItem | null>(null);

	const handleAddItem = (item: HardnessItem) => {
		const newItems = [...props.data, { ...item, id: props.data.length + 1 }];
		props.onDataChange(newItems);
	};

	const handleDeleteItem = (item: HardnessItem): void => {
		const newItems = props.data.filter((i) => i.id !== item.id);
		props.onDataChange(newItems);
	};

	const handleEditItem = (item: HardnessItem): void => {
		const index: number = props.data.findIndex((r) => r.id === item.id);

		const newItems = [...props.data];
		newItems[index] = { ...newItems[index], ...item };

		props.onDataChange(newItems);
		setItemToEdit(null);
	};

	const handleCancelEdit = (): void => {
		setItemToEdit(null);
	};

	return (
		<Fragment>
			{itemToEdit ? (
                <HardnessResultSummaryForm
                    initialItem={itemToEdit}
                    onSave={handleEditItem}
                    onCancel={handleCancelEdit}
                />
			) : (
				<HardnessResultSummaryForm onSave={handleAddItem} />
			)}

			<div className="divider my-4"></div>

			<AutTable
				data={props.data}
				tableColumns={hardnessResultColumns}
				onDeleteItem={handleDeleteItem}
				onEditItem={(item: HardnessItem) => setItemToEdit(item)}
			/>
		</Fragment>
	);
};

export default HardnessResultPreview;
